import { useQuery } from '@tanstack/react-query';

import { useBreakpointDown } from '@nesso/ui/hooks/use-breakpoint-down';

import { sessionByIdOptions } from '@/entities/session';
import {
    CopySessionNote,
    CopySessionNoteIntroPopover,
} from '@/features/session-note/copy-session-note';

import { useSessionId } from '../../../../model/use-session-id';
import { MarkDoneButton } from './session-note-footer-right-toolbar/mark-done-button';
import { NoteSavingIndicator } from './session-note-footer-right-toolbar/note-saving-indicator';

interface Props {
    isNoteSaving: boolean;
}

export function SessionNoteFooterRightToolbar({ isNoteSaving }: Props) {
    const sessionId = useSessionId();
    const { data: session } = useQuery(sessionByIdOptions(sessionId));
    const isSm = useBreakpointDown('sm');

    return (
        <div className="flex items-center gap-4">
            <NoteSavingIndicator
                isSaving={isNoteSaving}
                lastSavedAt={session?.currentNote?.updatedAt}
            />
            {!isSm && (
                <CopySessionNoteIntroPopover sessionId={sessionId}>
                    <CopySessionNote sessionId={sessionId} />
                </CopySessionNoteIntroPopover>
            )}
            <MarkDoneButton />
        </div>
    );
}
